const sampleFlashcards = [
  // JavaScript Flashcards
  {
    id: 1,
    title: "What is React?",
    answer: "React is a JavaScript library for building user interfaces.",
    category: "JavaScript",
  },
  {
    id: 2,
    title: "What is JSX?",
    answer:
      "JSX is a syntax extension for JavaScript that looks similar to XML or HTML.",
    category: "JavaScript",
  },
  {
    id: 3,
    title: "What is a Closure in JavaScript?",
    answer:
      "A closure is a function that retains access to its outer scope even after the outer function has finished executing.",
    category: "JavaScript",
  },
  {
    id: 4,
    title: "What is the difference between `let`, `const`, and `var`?",
    answer:
      "`var` is function-scoped, while `let` and `const` are block-scoped. `const` cannot be reassigned.",
    category: "JavaScript",
  },
  {
    id: 5,
    title: "What is the purpose of `useState` in React?",
    answer:
      "`useState` is a React Hook that allows function components to manage local state.",
    category: "JavaScript",
  },

  // Philippine Geography Flashcards
  {
    id: 6,
    title: "What is the capital of the Philippines?",
    answer: "Manila",
    category: "Geography - Philippines",
  },
  {
    id: 7,
    title: "What is the largest island in the Philippines?",
    answer: "Luzon",
    category: "Geography - Philippines",
  },
  {
    id: 8,
    title: "Which volcano in the Philippines is known as the 'Perfect Cone'?",
    answer: "Mayon Volcano",
    category: "Geography - Philippines",
  },
  {
    id: 9,
    title: "What is the longest river in the Philippines?",
    answer: "Cagayan River",
    category: "Geography - Philippines",
  },
  {
    id: 10,
    title: "What is the highest mountain in the Philippines?",
    answer: "Mount Apo",
    category: "Geography - Philippines",
  },
  {
    id: 11,
    title:
      "What is the smallest active volcano in the world, located in the Philippines?",
    answer: "Taal Volcano",
    category: "Geography - Philippines",
  },
  {
    id: 12,
    title: "Which city is known as the 'Summer Capital of the Philippines'?",
    answer: "Baguio City",
    category: "Geography - Philippines",
  },
];

export default sampleFlashcards;
